import { useState } from "react";
import { EditorState } from "prosemirror-state";

export default (config) => {
  const [state, setState] = useState(() => EditorState.create(config));
  const reconfigureState = (newConfig) => {
    const newState = EditorState.create({
      ...config,
      ...newConfig,
    });

    setState(newState);
  };

  return [state, setState, reconfigureState];
};
